import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// "Cliente attivo" condiviso dalle pagine social (PED, Storie, Campagne):
// scelto una volta, resta lo stesso passando da una pagina all'altra e alla visita dopo.
// Priorità: ?cliente_id= nel link → ultimo cliente scelto (per utente, nel browser).
const EVENT = 'eden-cliente-attivo';
const key = (user) => `eden-cliente-attivo:${user?.id || 'anon'}`;

function leggi(user) {
  try { return localStorage.getItem(key(user)) || ''; } catch { return ''; }
}

export function useClienteAttivo() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const daLink = params.get('cliente_id') || '';
  const [cliente, setStato] = useState(() => daLink || leggi(user));

  // Un link con ?cliente_id= vince e diventa il cliente attivo.
  useEffect(() => {
    if (daLink && daLink !== cliente) setStato(daLink);
    if (daLink) { try { localStorage.setItem(key(user), daLink); } catch {} }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daLink]);

  useEffect(() => {
    const h = () => setStato(leggi(user));
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, [user]);

  const setCliente = useCallback((id) => {
    setStato(id);
    try { localStorage.setItem(key(user), id); } catch {}
    window.dispatchEvent(new CustomEvent(EVENT));
    // Tiene il link condivisibile allineato, senza aggiungere voci alla cronologia.
    if (params.get('cliente_id')) {
      const p = new URLSearchParams(params);
      p.set('cliente_id', id);
      setParams(p, { replace: true });
    }
  }, [user, params, setParams]);

  return [cliente, setCliente];
}

// Ordine dei clienti nei selettori: prima gli attivi, poi il resto (ordine originale).
export function ordinaClienti(clienti = []) {
  return [...clienti].sort((a, b) => (a.stato === 'attivo' ? 0 : 1) - (b.stato === 'attivo' ? 0 : 1));
}

// Se il cliente salvato non esiste più (o non è visibile), ripiega sul primo della lista.
export function clienteValido(clienti, id) {
  if (!clienti.length) return id;
  return clienti.some(c => c.id === id) ? id : clienti[0].id;
}
